<template>
  <!-- 底部导航 -->
  <div class="footer">
    <div class="footer-centers">
      <div class="items ">
        <div>
          <img src="../assets/img/mobile.jpg" width="180" height="auto" />
          <p style="text-align: center;margin-top: 20px;">Mobile</p>
        </div>
      </div>
      <div class="items_nav">
        <div class="title">CONTACT INFORMATION</div>
        <div class="content"><span class="fonts">Add:</span> Yiwu International Expo Center, Zhejiang, China
        </div>
        <div class="content"><span class="fonts">Tel:</span>  +86-135-8600-1336</div>
        <div class="content"><span class="fonts">Mail:</span> daivd@fulgemtools.com</div>
        <div class="content"><span class="fonts">Whatsapp:</span> +86-138-5866-3169</div>
      </div>
      <div class="items_navs">
        <div class="title">LINKS</div>
        <div class="content"@click="goWindowPages('/product/1')">Products</div>
        <div class="content"@click="goWindowPages('/news/1')">Bolg</div>
        <div class="content"@click="goWindowPages('/download')">Download</div>
        <div class="content"@click="goWindowPages('/about/0')">About</div>
        <div class="content"@click="goWindowPages('/events/1')">Events</div>
        <div class="content"@click="goWindowPages('/video/1')">Video</div>
        <div class="content"@click="goWindowPages('/contact')">Contact</div>
      </div>

      <div class="items-share">
        <div class="p-share">
          <div class="share-t" @click="goView('https://facebook.com/')">
            <img src="../assets/img/03-1.png" style="width: 38px;height:auto"></img>
          </div>
          <div class="share-t" @click="goView('https://www.instagram.com/')">
            <img src="../assets/img/03-2.png" style="width: 38px;height:auto"></img>
          </div>
          <div class="share-t" @click="goView('https://twitter.com/')">
            <img src="../assets/img/03-3.png" style="width: 38px;height:auto"></img>
          </div>
          <div class="share-t" @click="goView('https://www.skype.com/')">
            <img src="../assets/img/03-4.png" style="width: 38px;height:auto"></img>
          </div>
          <div class="share-t" @click="goView('https://web.wechat.com/')">
            <img src="../assets/img/03-5.png" style="width: 38px;height:auto"></img>
          </div>
        </div>
      </div>
      <div class="items_navss">
        <div class="title">ARE YOU READY TO COOPERATE WITH US</div>
        <div class="centers">
          <el-form :model="form" label-width="0px" ref="loginForms" autocomplete="on" label-position="left"
            :rules="rules">
            <el-form-item>
              <el-input v-model="form.name" style="width: 49%;float: left;background: #fff;border-radius: 0px;" placeholder="Name"></el-input>
              <el-input v-model="form.email" style="width: 49%;float: right;background: #fff;border-radius: 0px;" placeholder="Email"></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 12px;">
              <el-input type="textarea" v-model="form.desc" placeholder="Message" style="border-radius: 0px"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="btn_send" @click.stop.prevent="Messageadds()">
                <span class="send_icon_text">SEND</span>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div >Copyright © 2024 Zhejiang Yingcheng International Trade Co., Ltd.<span @click="hrefss()" style="margin-left: 8px;margin-right: 8px;">  浙ICP备2024126782号  </span> Technical Support: <span @click="hrefs()">台州黑石网络</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-footer",
  data() {
    return {
      form: {
        name: '',
        email: '',
        description: '',
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],

      },
    }
  },
  methods: {
    phones() {
      window.location.href = `tel://+8613586001336`;
      //`tel://${phone}`
      // window.location.href = 'tel:+8613586001336';
    },
    goWindowPages(val) {
      let self = this
      self.$router.push(val)
      //location.reload()
    },
    hrefss(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    hrefs() {
      window.open('https://www.tzheishi.com/')
    },
    goView(url){
      window.open(url)
    },
    Messageadds() {
      let self = this;
      if (!self.form.name) {
        self.$layer.msg('Please Name');
        return
      }
      if (!self.form.email) {
        self.$layer.msg('Please email');
        return
      }
      if (!self.form.description) {
        self.$layer.msg('Please Message');
        return
      }
      this.$api.mall
        .Messageadd({
          name: self.form.name,
          description: self.form.description,
          email: self.form.email,
        })
        .then((res) => {
          if (res.code == 1) {
            self.$message.success("success");
            self.reset();
          } else {
            self.$message.error(res.msg);
          }
        });
    },
    goPages(val) {
      let self = this;
      this.$router.push(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input__inner {
  border: none !important;
}


@media screen and (min-width: 0px) and (max-width:1024px) {
  .footer {
    width: 100%;
    margin: 0px auto;
    overflow: hidden;
    background: #252525;
    color: #fff;
    box-sizing: border-box;

    .footer-centers {
      width: 90%;
      padding-top: 50px;
      overflow: hidden;
      box-sizing: border-box;
      margin: 0px auto;
      padding-bottom: 30px;

      .btn_send {
        color: #02999d;
        width: 160px;
        cursor: pointer;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: none;
        border: 2px solid #02999d;

        .send_icon_text {
          width: 58px;
          font-size: 18px;
          line-height: 50px;
          font-family:'Rany-Bold';
          margin: 0px auto;
          display: block;
          background: url(../assets/img/send.png) no-repeat right;
          background-size: 22px;
          padding-right: 28px;
          text-align: center;
        }
      }
    }

    .items-share {
      width: 90%;
      overflow: hidden;
      box-sizing: border-box;
      margin: 0px auto;

      .p-share {
        width: 70%;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        font-weight: 600;
        box-sizing: border-box;
        padding-bottom: 25px
      }
      .share-t {
        width:20%;
        overflow: hidden;
        margin: 0px auto;
        float: left;
        line-height: 45px;
        padding: 0px;
        display: flex;
        align-items: center;
        /* 垂直居中 */
        justify-content: center;
        /* 水平居中，如果需要的话 */
        font-size: 25px;
        color: #252525;
        text-align: center;
      
      }
    }

    .items_navs {
      display: none;
    }

    .items_navss {
      width: 100%;
      margin: 0px auto;
      overflow: hidden;
      box-sizing: border-box;
      color: #fff;

      .title {
        font-size: 16px;
        color: #fff;
        text-align: center;
        padding-bottom: 25px;
        font-weight: 600;
      }

      .content:hover {
        cursor: pointer;
        color: #019a91;
      }

      .content {
        color: #6a6a6a;
        margin-top: 6px;
        line-height: 25px;
        font-size: 18px;
      }
    }

    .items {
      display: none;
    }

    .items_nav {
      display: none;
    }

    .footer-bottom {
      color: #fff;
      overflow: hidden;
      font-size: 14px;
      width: 100%;
      text-align: center;
      border-top: 2px solid #515151;

      div {
        width: 80%;
        overflow: hidden;
        margin: 10px auto;
      }
    }
  }
}


@media screen and (min-width: 1024px) and (max-width:1600px) {
  .footer {
    width: 100%;
    margin: 0px auto;
    overflow: hidden;
    background: #252525;
    box-sizing: border-box;
    
    .items-share {
      display: none;
    }

    .footer-bottom {
      color: #fff;
      line-height: 80px;
      overflow: hidden;
      font-size: 15px;
      width: 100%;
      text-align: center;
      border-top: 2px solid #515151;
    }

    .footer-centers {
      width: 1200px;
      padding-top: 80px;
      overflow: hidden;
      box-sizing: border-box;
      margin: 0px auto;
      padding-bottom: 50px;

      .btn_send {
        color: #02999d;
        width: 160px;
        cursor: pointer;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: none;
        border: 2px solid #02999d;

        .send_icon_text {
          width: 58px;
          font-size: 18px;
          line-height: 50px;
          margin: 0px auto;
          display: block;
          background: url(../assets/img/send.png) no-repeat right;
          background-size: 22px;
          padding-right: 28px;
          text-align: center;
        }
      }

      .items_navs {
        float: left;
        margin-left: 56px;
        overflow: hidden;
        box-sizing: border-box;
        color: #fff;

        .title {
          font-size: 24px;
          color: #fff;
          padding-bottom: 25px;
          font-weight: 600;
        }

        .content:hover {
          cursor: pointer;
          color: #019a91;
        }

        .content {
          color: #6a6a6a;
          margin-top: 6px;
          line-height: 25px;
          font-size: 18px;
        }
      }

      .items_navss {
        float: left;
        margin-left: 56px;
        overflow: hidden;
        box-sizing: border-box;
        color: #fff;

        .title {
          font-size: 24px;
          color: #fff;
          padding-bottom: 25px;
          font-weight: 600;
        }

        .content:hover {
          cursor: pointer;
          color: #019a91;
        }

        .content {
          color: #6a6a6a;
          margin-top: 6px;
          line-height: 25px;
          font-size: 18px;
        }
      }

      .items_nav {
        float: left;
        margin-left: 56px;
        overflow: hidden;
        box-sizing: border-box;
        color: #fff;

        .title {
          font-size: 24px;
          color: #fff;
          padding-bottom: 25px;
          font-weight: 600;
        }

        .content:hover {
          cursor: pointer;
          color: #019a91;
        }

        .content {
          color: #6a6a6a;
          width: 300px;
          margin-top: 12px;
          line-height: 25px;
          font-size: 18px;

          .fonts {
            color: #019a91;
          }
        }
      }

      .items {
        width: 180px;
        float: left;
        margin-left: 0px;
        overflow: hidden;
        box-sizing: border-box;
        color: #fff;
      }
    }
  }


}

@media screen and (min-width: 1601px) and (max-width:8000px) {
  .footer {
    width: 100%;
    margin: 0px auto;
    overflow: hidden;
    background: #252525;
    box-sizing: border-box;
    
    .items-share {
      display: none;
    }

    .footer-bottom {
      color: #fff;
      line-height: 80px;
      overflow: hidden;
      font-size: 15px;
      width: 100%;
      text-align: center;
      border-top: 2px solid #515151;
    }

    .footer-centers {
      width: 1600px;
      padding-top: 80px;
      overflow: hidden;
      box-sizing: border-box;
      margin: 0px auto;
      padding-bottom: 50px;

      .btn_send {
        color: #02999d;
        width: 160px;
        cursor: pointer;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: none;
        border: 2px solid #02999d;

        .send_icon_text {
          width: 58px;
          font-size: 18px;
          line-height: 50px;
          margin: 0px auto;
          display: block;
          background: url(../assets/img/send.png) no-repeat right;
          background-size: 22px;
          padding-right: 28px;
          text-align: center;
        }
      }

      .items_navs {
        float: left;
        margin-left: 120px;
        overflow: hidden;
        box-sizing: border-box;
        color: #fff;

        .title {
          font-size: 24px;
          color: #fff;
          padding-bottom: 25px;
          font-weight: 600;
        }

        .content:hover {
          cursor: pointer;
          color: #019a91;
        }

        .content {
          color: #6a6a6a;
          margin-top: 6px;
          line-height: 25px;
          font-size: 18px;
        }
      }

      .items_navss {
        float: left;
        margin-left: 120px;
        overflow: hidden;
        box-sizing: border-box;
        color: #fff;

        .title {
          font-size: 24px;
          color: #fff;
          padding-bottom: 25px;
          font-weight: 600;
        }

        .content:hover {
          cursor: pointer;
          color: #019a91;
        }

        .content {
          color: #6a6a6a;
          margin-top: 6px;
          line-height: 25px;
          font-size: 18px;
        }
      }

      .items_nav {
        float: left;
        margin-left: 120px;
        overflow: hidden;
        box-sizing: border-box;
        color: #fff;

        .title {
          font-size: 24px;
          color: #fff;
          padding-bottom: 25px;
          font-weight: 600;
        }

        .content:hover {
          cursor: pointer;
          color: #019a91;
        }

        .content {
          color: #6a6a6a;
          width: 300px;
          margin-top: 12px;
          line-height: 25px;
          font-size: 18px;

          .fonts {
            color: #019a91;
          }
        }
      }

      .items {
        width: 180px;
        float: left;
        margin-left: 60px;
        overflow: hidden;
        box-sizing: border-box;
        color: #fff;
      }
    }
  }
}
</style>
